import { Tag, Tooltip } from "antd";
import React from "react";

/**
 * Marks a row that the school group published rather than this branch.
 *
 * Group rows are shared by reference across every Junior branch, so a branch
 * admin sees them but cannot edit or delete them — the badge is what explains
 * why the usual controls are missing.
 */
function GroupBadge({ compact = false }) {
  return (
    <Tooltip title="Published by your school group. Edit it from the Group Console.">
      <Tag color="geekblue" style={compact ? { marginInlineEnd: 0 } : undefined}>
        Group
      </Tag>
    </Tooltip>
  );
}

/** A row belongs to the group when it carries a group id instead of a class. */
export function isGroupRow(record) {
  return !!record?.group;
}

export default GroupBadge;
